import { useState, useEffect } from 'react'
import { Dialog, DialogBody, DialogContent, DialogTitle } from '@cutilei/ui'
import AuthService from '../../../services/auth'
import { connectSocket, SocketRoom } from '../../../services/socket'
import MainButton from '../../../components/Buttons/MainButton'
import Logo from '../../../icons/logo-name.png'
import { FaWhatsapp } from 'react-icons/fa'

import {
  Container,
  Body,
  Image,
  InfoText
} from './styles'

export default function InactiveBusinessModal ({
  visible,
  status,
  onClose: handleClose
}) {
  const [showCloseButton, setShowCloseButton] = useState (false)
  const businessId = AuthService.getBusinessId ()
  const token = AuthService.getToken ()

  useEffect (() => {
    const newSocket = connectSocket ({
      token, rooms: [SocketRoom.business (businessId)]
    })

    newSocket.on (`${businessId}_business_activated`, () => setShowCloseButton (true))

    return () => {newSocket.disconnect ()}
  }, [businessId, token])

  const renderMessage = () => {
    if (status === 'pending') {
      return (
        <Body>
          <DialogTitle>Você está quase lá!</DialogTitle>
          <InfoText>
            Estamos verificando seu cadastro.
          </InfoText>
          <InfoText>
            Em instantes, sua área logada será liberada para que você possa prosseguir com as configurações de seu salão.
          </InfoText>
        </Body>
      )
    }

    if (status === 'inactive') {
      return (
        <Body>
          <DialogTitle>Seu salão está inativo</DialogTitle>
          <InfoText>
            Entre em contato com o suporte para reativar seu salão.
          </InfoText>
          <MainButton
            label='Falar com o suporte'
            onClick={() => window.open ('https://wa.me/message/SH5AWAQ6UP4IF1', '_blank')}
            leftIcon={<FaWhatsapp size={16} color='#000000' style={{marginBottom: 2}}/>}
            style={{marginTop: 10}}
            width={190}
          />
        </Body>
      )
    }
  }

  return (
    <Dialog open={visible}>
      <DialogContent
        showCloseButton={false}
        closeOnOutsideClick={false}
        aria-describedby={undefined}
        // Só fecha pelo Prosseguir, depois que o salão é ativado: sem X, sem Esc e sem clique fora
        onEscapeKeyDown={event => event.preventDefault()}
      >
        <DialogBody>
          <Container>
            <Image src={Logo} alt='Cutilei'/>
            {showCloseButton ? (
              <Body>
                <DialogTitle>Seu salão foi ativado!</DialogTitle>
                <InfoText>
                  Agora, prossiga para as etapas de configuração para começar a atender.
                </InfoText>
                <MainButton
                  label='Prosseguir'
                  onClick={handleClose}
                  style={{marginTop: 10}}
                  width={140}
                />
              </Body>
            ) : renderMessage ()}
          </Container>
        </DialogBody>
      </DialogContent>
    </Dialog>
  )
}
